import React from 'react';
import { FormattedMessage } from 'react-intl';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { Text } from '@/components/atoms/Text';
import { Title } from '@/components/atoms/Title';
import { SVGIcon, SVGIcons } from '@/components/atoms/Icon/SVGIcon';
import { routes } from '@/core/router/routes';
import {
    Container,
    IntegrationSection,
    IntegrationLeft,
    IntegrationRight,
    IntegrationDescription,
    WebhookContainer,
    WebhookCard,
    AddWebhookCard,
    StretchedCard,
    WebhookImage,
    SystemBadge,
} from './Integrations.style';
import { useIntegrationsVM } from './Integrations.viewmodel';
import { ENV } from '@/utils/env';

const Integrations: React.FunctionComponent<React.PropsWithChildren> = () => {
    const { goToCreateWebhook, goToEditWebhook, webhooks, isLoadingWebhooks } = useIntegrationsVM();

    const tabRoutes = React.useMemo(() => routes.filter(({ tab }) => tab === 'brands'), []);

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            goToCreateWebhook();
        }
    };

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <Container>
                <IntegrationSection>
                    <IntegrationLeft>
                        <Title text="integrations.webhooks.title" />
                        <IntegrationDescription>
                            <Text text="integrations.webhooks.description" />
                        </IntegrationDescription>
                    </IntegrationLeft>
                    <IntegrationRight>
                        <StretchedCard>
                            <WebhookContainer>
                                {!isLoadingWebhooks &&
                                    webhooks.map((webhook) => (
                                        <WebhookCard
                                            key={webhook.moduleExternalWebhookId}
                                            onClick={() => goToEditWebhook(webhook.moduleExternalWebhookId)}
                                            title={webhook.webhookUrl}
                                            isSystem={webhook.isSystem}
                                        >
                                            {webhook.isSystem && (
                                                <SystemBadge>
                                                    <FormattedMessage id="webhook.system.badge" />
                                                </SystemBadge>
                                            )}
                                            <WebhookImage
                                                src={`${ENV.STATIC_URL}/dashboard/images/webhook.png`}
                                                alt="Webhook"
                                            />
                                        </WebhookCard>
                                    ))}
                                <AddWebhookCard
                                    onClick={goToCreateWebhook}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={handleKeyDown}
                                >
                                    <SVGIcon icon={SVGIcons.PLUS} size={40} />
                                </AddWebhookCard>
                            </WebhookContainer>
                        </StretchedCard>
                    </IntegrationRight>
                </IntegrationSection>
            </Container>
        </RouterNavigationTabs>
    );
};

export default Integrations;
